class AuthenticationModel {

    constructor(token) {
        this.token = token;
    }

}

export default AuthenticationModel